import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { getStateLayerColor } from '@web/ui/theme/utils';

export const CommandButton = styled.button`
  padding: ${({ theme }) => theme.spacing('0250')};
  border-style: solid;
  border-width: ${({ theme }) => theme.outline['1']};
  border-radius: ${({ theme }) => theme.shape.corner['0250']};
  border-color: ${({ theme }) => theme.color.greenFixed};
  background-color: transparent;

  color: ${({ theme }) => theme.color.greenFixed};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};

  text-shadow: 0px 0px 4px ${({ theme }) => theme.color.greenFixed};
  transition: outline 100ms;

  cursor: pointer;

  &:hover {
    outline-style: solid;
    outline-width: ${({ theme }) => theme.outline['1']};
    outline-color: ${({ theme }) => theme.color.greenFixed};
  }

  &:active {
    border-radius: ${({ theme }) => theme.shape.corner['0500']};
  }
`;

const blinkAnimation = keyframes`
  0% {
    visibility: visible;
  }
  50% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
`;

export const CommandLineEntry = styled.p<{
  prefix?: string;
  centered?: boolean;
  withCursor?: boolean;
  whiteSpace?: string;
}>`
  color: ${({ theme }) => theme.color.greenFixed};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};

  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};

  display: flex;
  white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'pre')};
  align-items: ${({ centered }) => centered && 'center'};

  &:before {
    content: ${({ prefix }) => (prefix ? `'${prefix} '` : undefined)};
  }

  &:after {
    content: ${({ withCursor }) => withCursor && "''"};
    width: 6px;
    height: 16px;
    background: currentColor;
    display: inline-block;
    animation: ${blinkAnimation} 1.5s step-start infinite;
  }

  ${({ theme }) => theme.breakpoints.down('lg')} {
    white-space: break-spaces;

    &#staking-console-help {
      display: inline;
    }
  }
`;

export const BaseTile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.shape.corner['1250']};

  color: ${({ theme }) => theme.color.greenFixed};
  font: ${({ theme }) => theme.typography.body.bold};
  font-size: ${({ theme }) => theme.typescale.size['1']};

  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};

  background-image: ${getStateLayerColor('greenFixed', 'semiTransparent')};
`;

export const CommandLineEntryStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('1000')};
`;

export const BackgroundStroke = styled.div`
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(black, black 2px, grey 2px, grey 5px);
  opacity: 0.1;
  mix-blend-mode: overlay;
  pointer-events: none;
  z-index: 10;
`;
